<!--
 * @Author: ningbo.kang
 * @Date: 2020-09-07 14:58:29
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-09-15 14:15:00
 * @Description: 描述
-->
<template>
  <div class="ant-select ant-select-allow-clear ant-select-no-arrow"
    :class="{
      'ant-select-enabled': !disabled,
      'ant-select-disabled': disabled,
    }">
    <div class="link-tag-content ant-select-selection">
      <div class="ant-select-selection__rendered">
        <a-tag v-for="(item, key) in text"
          :key="item.url || item"
          @close="handleClose(key)"
          :closable="!disabled"
          class="link-tag">
          <template v-if="isRouterLink(item.url)">
            <router-link target="_blank"
              :to="{
                path: item.url,
                query: { title: item.title },
              }">{{ item.title || item }}</router-link>
          </template>
          <template v-else>
            <a target="_blank"
              :href="item.url">{{ item.title || item }}</a>
          </template>
        </a-tag>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: [],
    };
  },
  watch: {
    value: {
      handler(val, pre) {
        this.initVal(val, pre);
      },
      immediate: true,
    },
  },
  methods: {
    initVal(val) {
      let strVal = val;
      if (val === undefined || val === null || val === '') {
        strVal = '[]';
      }
      try {
        const value = JSON.parse(strVal);
        this.text = value.map(item => ({
          title: item.title,
          url: item.url,
        }));
      } catch (error) {
        this.text = [];
      }
    },
    handleClose(key) {
      if (this.multiple) {
        // const result = this.text.filter((item, index) => key !== index).map(item => JSON.stringify(item));
        const result = this.text.filter((item, index) => key !== index);
        this.$emit('delete', result);
      } else {
        this.$emit('delete', null);
      }
    },
    isRouterLink(url) {
      const routerLinkFlag = url && (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//'));
      if (routerLinkFlag) {
        return false;
      }
      return true;
    },
  },
};
</script>
